/**
 * Fire InitiateCheckout before Shop Pay leaves luuve.co.
 * Publishes Shopify custom event `luuve_begin_checkout` for the Data Layer pixel.
 * Do not load GTM here.
 */
(function () {
  var COOKIE = "luuve_ic_sent";
  var publishing = false;

  function setSentCookie() {
    try {
      document.cookie = COOKIE + "=1; path=/; max-age=1800; SameSite=Lax";
    } catch (e) {}
  }

  function mapCart(cart) {
    if (!cart) return { source: "click" };
    var items = cart.items || [];
    var mapped = [];
    for (var i = 0; i < items.length; i++) {
      var line = items[i];
      var plan =
        line.selling_plan_allocation && line.selling_plan_allocation.selling_plan
          ? line.selling_plan_allocation.selling_plan
          : null;
      mapped.push({
        item_id: String(line.product_id),
        item_variant: String(line.variant_id || line.id),
        item_name: line.product_title || line.title,
        item_category: line.product_type,
        item_brand: line.vendor,
        item_delivery: "home_delivery",
        price: Number(line.price) / 100,
        quantity: line.quantity,
        item_selling_plan: plan && plan.name ? plan.name : null
      });
    }
    return {
      source: "click",
      token: cart.token || "",
      currency: cart.currency || "USD",
      value: Number(cart.total_price) / 100,
      item_count: cart.item_count,
      items: mapped
    };
  }

  function publish(payload) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === "function") {
        Shopify.analytics.publish("luuve_begin_checkout", payload || { source: "click" });
      }
    } catch (e) {}
  }

  function publishBeginCheckout() {
    if (publishing) return;
    publishing = true;
    setTimeout(function () {
      publishing = false;
    }, 2000);

    setSentCookie();

    var done = false;
    function finish(payload) {
      if (done) return;
      done = true;
      publish(payload);
    }

    var timer = setTimeout(function () {
      finish({ source: "click" });
    }, 250);

    fetch("/cart.js", { credentials: "same-origin" })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        clearTimeout(timer);
        finish(mapCart(cart));
      })
      .catch(function () {
        clearTimeout(timer);
        finish({ source: "click" });
      });
  }

  function isBeginCheckoutNode(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.matches) {
      if (
        node.matches(
          '[name="checkout"], [data-checkout-button], #checkout, .shopify-payment-button, .shopify-payment-button__button, .additional-checkout-buttons, shopify-accelerated-checkout, shopify-accelerated-checkout-cart, [data-shopify="payment-button"]'
        )
      ) {
        return true;
      }
    }
    if (node.closest) {
      if (
        node.closest(
          '[name="checkout"], [data-checkout-button], #checkout, .shopify-payment-button, .additional-checkout-buttons, shopify-accelerated-checkout, shopify-accelerated-checkout-cart, [data-shopify="payment-button"]'
        )
      ) {
        return true;
      }
    }
    return false;
  }

  function isBeginCheckoutEvent(event) {
    var path = event.composedPath ? event.composedPath() : [event.target];
    for (var i = 0; i < path.length; i++) {
      if (isBeginCheckoutNode(path[i])) return true;
    }
    return false;
  }

  document.addEventListener(
    "click",
    function (event) {
      if (isBeginCheckoutEvent(event)) publishBeginCheckout();
    },
    true
  );

  document.addEventListener(
    "submit",
    function (event) {
      var submitter = event.submitter;
      if (submitter && (submitter.getAttribute("name") === "checkout" || submitter.id === "checkout")) {
        publishBeginCheckout();
      }
    },
    true
  );
})();
